import api from "@/api"

const state = {
  instantDeliveryList: []
}
const actions = {
  getInstantDeliveries({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.instantDelivery.instantDeliveries(params).then(
        (response) => {
          commit("setInstantDeliveries", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setInstantDeliveries(state, value) {
    state.instantDeliveryList = value
  }
}
const getters = {
  instantDeliveryList: (state) => state.instantDeliveryList
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
